import { AddFilterBaseFunc, FilterContext, RemoveFilterBaseFunc } from "../core";
import { DashboardFilterKeys, Filters, IChartData, IDashboardDimensionsViewModel } from "./plotdata";
export { type IChartData, type IDashboardDimensionsViewModel, DashboardFilterKeys, type Filters } from "./plotdata";
export type AddFilterFunc = AddFilterBaseFunc<typeof DashboardFilterKeys>;
export type RemoveFilterFunc = RemoveFilterBaseFunc<typeof DashboardFilterKeys>;

import * as DashWorker from "./worker";

export interface IMDTDashboard {
	allData: boolean;
	references: IDashboardDimensionsViewModel;
	filters: Filters;
	chartData: IChartData;
	selectedFacilities: Set<string>;
    selectedHhses: Set<string>;
}


export const initState = (): IMDTDashboard => {
	return {
		allData: false,
		references: {},
		chartData: null,
		filters: {},
		selectedFacilities: new Set(),
		selectedHhses: new Set(),
	}
};


export const loadMdtDashboard = async (state: IMDTDashboard): Promise<IMDTDashboard> => {
	DashWorker.start();
	try {
		await DashWorker.ping()
		console.log("WORKER PING RESOLVED");
		return await fetchData(state, state.allData);
	} catch {
		console.error("WORKER PING FAILED");
	}
}

export const loadSurvivalDashboard = async (state: IMDTDashboard, service: any, primarySite: any, activeFilters: Filters): Promise<IMDTDashboard> => {
	try {
		await DashWorker.ping()
		return await fetchSurvivalData(state, false, service, primarySite, activeFilters);
	} catch {
		console.error("LOADING SURVIVAL DATA FAILED");
	}
}

export const clearFilters = (state: IMDTDashboard): IMDTDashboard => {
	const maybeSetDefaultFilter = (filterKey: string, dimensions: { name: string }[]): Set<string>  => {
		if (!dimensions || dimensions.length !== 1)
			return (new Set<string>());

		if (state.allData)
			return (new Set<string>());

		let filterSet = new Set<string>();
		filterSet.add(dimensions[0].name);

		state = addFilter(state)(filterKey, [dimensions[0].name])
		return filterSet;
	}

	state.filters = {};
	state.selectedHhses  = maybeSetDefaultFilter(DashboardFilterKeys.HHS.key, state.chartData.hhses);
	state.selectedFacilities = maybeSetDefaultFilter(DashboardFilterKeys.Facility.key, state.chartData.facilities);

	return { ... state };

}



export const closeMdtDashboard = () =>
	DashWorker.stop();

const fetchData = async (state: IMDTDashboard, all: boolean): Promise<IMDTDashboard> => {
	try {
		const data = await DashWorker.fetch(all);

		const maybeSetDefaultFilter = (filterKey: string, dimensions: { name: string }[]): Set<string>  => {
			if (!dimensions || dimensions.length !== 1)
				return (new Set<string>());

			if (all)
				return (new Set<string>());

			let filterSet = new Set<string>();
			filterSet.add(dimensions[0].name);

			state = addFilter(state)(filterKey, [dimensions[0].name])
			return filterSet;
		}

		state.selectedHhses  = maybeSetDefaultFilter(DashboardFilterKeys.HHS.key, data.chartData.hhses);
        state.selectedFacilities = maybeSetDefaultFilter(DashboardFilterKeys.Facility.key, data.chartData.facilities);
		state.allData = all;
		state.references = data.references;
		state.chartData = data.chartData;
		
		return state;
	} catch {
		console.error("WORKER FETCHDATA FAILED");
		return state;
	}
}

const fetchSurvivalData = async (state: IMDTDashboard, all: boolean, service: any, primarySite: any, activeFilters: Filters): Promise<IMDTDashboard> => {
	try {
		const data = await DashWorker.fetchSurvival(all, service, primarySite, activeFilters);
		state.chartData = data.chartData;
		return state;
	} catch {
		console.error("WORKER FETCHDATA FAILED");
		return state;
	}
}

export const computeChartData = async (state: IMDTDashboard): Promise<IMDTDashboard>  => {
	try {
		const data = await DashWorker.chartData(state.filters);
		state.chartData = data;
		return {...state};
	} catch {
		console.error("WORKER COMPUTECHARTDATA FAILED")
		return state;
	}
}

export const addFilter = (state: IMDTDashboard) => (key: keyof typeof DashboardFilterKeys, value: string | string[], context?: FilterContext, labelOverride?: string): IMDTDashboard => {
	const filters: Filters = Object.assign({}, state.filters);
	const values = (typeof value === "string")
		? [value]
		: value;

	//Replace the existing path entry if we are replacing a multi-value filter
	//to do so: traverse to the parent
	const baseContext: FilterContext = context && ((context.values().length > 1) ? context.parent() : context) || new FilterContext();
	baseContext.push(values);

	filters[key] = ({ value: values, labelOverride, parts: baseContext.parts });

	state.filters = filters;

	return {...state};
}


export const removeFilter = (state: IMDTDashboard, key: keyof typeof DashboardFilterKeys, value?: string | number): IMDTDashboard => {
	const filters: Filters = Object.assign({}, state.filters);
	if (filters[key].value.length > 1 && value) {
		filters[key].value.splice(filters[key].value.findIndex(a => a == value), 1)
	} else {
		delete filters[key];
	}

	state.filters = filters;
	return {...state};
}



    /**
 * Exports a string with the current filters selected and their values.
 */
export function extractFilterLabel(filterValues, spacer) {

let filters = [];

for (const key in DashboardFilterKeys) {
	if (Object.prototype.hasOwnProperty.call(DashboardFilterKeys, key)) {
		filters.push({"key": key, "label": DashboardFilterKeys[key].label});
	}
}

let filterString = "";
	if (filterValues) {
	for (var key of Object.keys(filterValues)) {
			filterValues[key].parts.forEach(p => {
				filterString += ((filters.find(id => id.key == key).label + ":" +" " + p + spacer));
				})       
	
	}
}

return filterString.substring(0, filterString.length -2);
}
